import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FunctionGetDataFromS3 } from "../utils/useFunction";

export const LoadDataFromS3 = createAsyncThunk("loadData/data", async () => {
  // const jsonData = await FunctionGetDataFromS3("static-data.json");
  const jsonData = await FunctionGetDataFromS3("static-data.json");

  const programs = jsonData?.programs;
  const config = jsonData?.config;
  const water = jsonData?.water;
  const addons = jsonData?.addons;
  const addons_no_index = jsonData?.addons_no_index;

  return {
    programs,
    config,
    water,
    addons,
    // banner: jsonDataBanner,
    addons_no_index,
    version: jsonData?.version,
  };
  //   } catch (error) {}
});

const initialState = {
  programs: null,
  config: null,
  water: null,
  addons: null,
  // banner: null,
  addons_no_index: null,
  version: null,
};

const loadSlice = createSlice({
  name: "loadData",
  initialState,
  extraReducers: {
    [LoadDataFromS3.fulfilled]: (state, action) => {
      state.programs = action.payload.programs;
      state.config = action.payload.config;
      state.water = action.payload.water;
      state.addons = action.payload.addons;
      // state.banner = action.payload.banner;
      state.addons_no_index = action.payload.addons_no_index;
      state.version = action.payload.version;
    },
  },
});

export default loadSlice.reducer;
